@if (showLoader()) {
<div class="app-loader-container">
  <app-loader />
</div>
}
<router-outlet></router-outlet>
<app-minimized-bar></app-minimized-bar>
